import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { fetchPackages } from "../redux/packageSlice";

const Packages = () => {
  const dispatch = useDispatch();
  const { items: packages, loading } = useSelector((state) => state.packages);

  useEffect(() => {
    dispatch(fetchPackages({ isActive: "true", showOnHomepage: "true" }));
  }, [dispatch]);

  const visiblePackages = packages.filter((p) => p.isActive && p.showOnHomepage);

  if (!loading && visiblePackages.length === 0) return null;

  const scrollToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="packages"
      style={{
        background:
          "linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #0f172a 100%)",
        padding: "96px 0",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Dekoratif daireler */}
      <div
        style={{
          position: "absolute",
          top: "-15%",
          right: "-5%",
          width: 600,
          height: 600,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(37,99,235,0.12) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-20%",
          left: "-8%",
          width: 500,
          height: 500,
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(99,102,241,0.1) 0%, transparent 70%)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          padding: "0 24px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Başlık */}
        <motion.div
          style={{ textAlign: "center", marginBottom: 72 }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span
            style={{
              display: "inline-block",
              background: "rgba(37,99,235,0.2)",
              border: "1px solid rgba(37,99,235,0.4)",
              borderRadius: 100,
              padding: "6px 20px",
              color: "#93c5fd",
              fontSize: 13,
              fontWeight: 600,
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              marginBottom: 20,
            }}
          >
            Seans Paketleri
          </span>
          <h2
            style={{
              color: "#fff",
              fontSize: "clamp(32px, 5vw, 52px)",
              fontWeight: 800,
              lineHeight: 1.15,
              margin: "0 0 20px",
            }}
          >
            Çocuğunuz İçin En Uygun Paketi Seçin
          </h2>
          <p
            style={{
              color: "rgba(255,255,255,0.55)",
              fontSize: "clamp(16px, 2vw, 19px)",
              lineHeight: 1.7,
              maxWidth: 580,
              margin: "0 auto",
            }}
          >
            Düzenli seans takibi ile çocuğunuzun gelişimini daha verimli ve
            tasarruflu destekleyin
          </p>
        </motion.div>

        {/* Paket Kartları */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              visiblePackages.length === 1
                ? "1fr"
                : visiblePackages.length === 2
                  ? "repeat(auto-fit, minmax(300px, 1fr))"
                  : "repeat(auto-fit, minmax(280px, 1fr))",
            gap: 28,
            maxWidth:
              visiblePackages.length === 1
                ? 400
                : visiblePackages.length === 2
                  ? 720
                  : "100%",
            margin: "0 auto",
          }}
        >
          {visiblePackages.map((pkg, index) => (
            <motion.div
              key={pkg._id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: index * 0.12 }}
              whileHover={{ y: -6 }}
              style={{
                background: "rgba(255,255,255,0.05)",
                backdropFilter: "blur(16px)",
                border: `1px solid ${pkg.color || "#2563EB"}40`,
                borderRadius: 24,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                transition: "box-shadow 0.3s",
                boxShadow: `0 8px 32px rgba(0,0,0,0.3), 0 0 0 1px ${pkg.color || "#2563EB"}20`,
              }}
            >
              {/* Üst renk bandı */}
              <div
                style={{
                  height: 5,
                  background: `linear-gradient(90deg, ${pkg.color || "#2563EB"}, ${pkg.color || "#2563EB"}88)`,
                }}
              />

              <div
                style={{
                  padding: "32px 28px 28px",
                  display: "flex",
                  flexDirection: "column",
                  flex: 1,
                }}
              >
                {/* İkon + İsim */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14,
                    marginBottom: 18,
                  }}
                >
                  <div
                    style={{
                      width: 52,
                      height: 52,
                      borderRadius: 14,
                      flexShrink: 0,
                      background: `${pkg.color || "#2563EB"}25`,
                      border: `1px solid ${pkg.color || "#2563EB"}40`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      width="26"
                      height="26"
                      fill="none"
                      stroke={pkg.color || "#2563EB"}
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.8}
                        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                      />
                    </svg>
                  </div>
                  <h3
                    style={{
                      color: "#fff",
                      fontSize: 20,
                      fontWeight: 700,
                      margin: 0,
                      lineHeight: 1.3,
                    }}
                  >
                    {pkg.name}
                  </h3>
                </div>

                {/* Açıklama */}
                {pkg.description && (
                  <p
                    style={{
                      color: "rgba(255,255,255,0.5)",
                      fontSize: 15,
                      lineHeight: 1.65,
                      marginBottom: 24,
                      margin: "0 0 24px",
                    }}
                  >
                    {pkg.description}
                  </p>
                )}

                {/* Seans sayısı kutusu */}
                <div
                  style={{
                    background: `${pkg.color || "#2563EB"}18`,
                    border: `1px solid ${pkg.color || "#2563EB"}30`,
                    borderRadius: 16,
                    padding: "24px 20px",
                    textAlign: "center",
                    marginBottom: 24,
                  }}
                >
                  <div
                    style={{
                      color: pkg.color || "#2563EB",
                      fontSize: 64,
                      fontWeight: 900,
                      lineHeight: 1,
                      marginBottom: 6,
                      letterSpacing: "-2px",
                    }}
                  >
                    {pkg.sessionCount}
                  </div>
                  <div
                    style={{
                      color: "rgba(255,255,255,0.45)",
                      fontSize: 13,
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.12em",
                    }}
                  >
                    Seans
                  </div>
                </div>

                {/* Fiyat */}
                <div style={{ marginTop: "auto" }}>
                  <button
                    href="https://wa.me/+905055517747"
                    style={{
                      width: "100%",
                      background: `linear-gradient(135deg, ${pkg.color || "#2563EB"}, ${pkg.color || "#2563EB"}cc)`,
                      border: "none",
                      borderRadius: 12,
                      padding: "16px",
                      color: "#fff",
                      fontSize: 16,
                      fontWeight: 700,
                      cursor: "pointer",
                      transition: "opacity 0.2s, transform 0.15s",
                      boxShadow: `0 4px 20px ${pkg.color || "#2563EB"}50`,
                      letterSpacing: "0.02em",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.opacity = "0.88";
                      e.currentTarget.style.transform = "scale(1.02)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.opacity = "1";
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  >
                    <a href="https://wa.me/+905055517747" target="_blank" rel="noopener noreferrer">
                      Paketi Al
                    </a>
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Alt not */}
        <motion.p
          style={{
            textAlign: "center",
            color: "rgba(255,255,255,0.3)",
            fontSize: 14,
            marginTop: 48,
          }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          Paket satın almak için{" "}
          <button
            onClick={scrollToContact}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#93c5fd",
              fontWeight: 600,
              fontSize: 14,
              textDecoration: "underline",
              textUnderlineOffset: 3,
              padding: 0,
            }}
          >
            bizimle iletişime geçin
          </button>
          . Paketler görüşme sonrası sisteme tanımlanır.
        </motion.p>
      </div>
    </section>
  );
};

export default Packages;
